import { HeaderGroup } from 'react-table';

import FaIcon from '@components/FaIcon';
import MDBox from '@components/MDBox';
import MDTypography from '@components/MDTypography';

export type sortedValue = false | 'desc' | 'asce' | 'none' | undefined;

interface IStickyHeaderProps {
  column: HeaderGroup<object>;
  sorted?: sortedValue;
}

const StickyHeader = ({ column, sorted }: IStickyHeaderProps) => (
  <div
    {...column.getHeaderProps(column.getSortByToggleProps())}
    title=''
    className='th'
    key='da'
  >
    <MDBox component='div' py={0} px={1}>
      <MDBox
        position='relative'
        color='secondary'
        display='flex'
        gap={1}
        alignItems='center'
        opacity={0.7}
      >
        {sorted && (
          <MDBox
            sx={({ typography: { size } }: any) => ({
              fontSize: size.lg
            })}
          >
            <MDBox
              color={sorted === 'asce' ? 'text' : 'secondary'}
              opacity={sorted === 'asce' ? 1 : 0.5}
            >
              <FaIcon icon='caret-up' />
            </MDBox>
            <MDBox
              marginTop={-3}
              color={sorted === 'desc' ? 'text' : 'secondary'}
              opacity={sorted === 'desc' ? 1 : 0.5}
            >
              <FaIcon icon='caret-down' />
            </MDBox>
          </MDBox>
        )}
        <MDBox>
          <MDTypography
            variant='h6'
            color='info'
            sx={() => ({
              textTransform: 'uppercase',
              whiteSpace: 'pre-wrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical'
            })}
          >
            {column.render('Header')}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  </div>
);

export default StickyHeader;
